import { Component } from '@angular/core';

@Component({
	selector: 'app-settings',
	templateUrl: './settings.component.html',
	styleUrls: ['./settings.component.css'],
})
export class SettingsComponent {
	sheepType: string = localStorage.sheepType ? localStorage.sheepType : 'esheep';

	constructor() {}

	sheepTypeChanged() {
		localStorage.setItem('esheepType', this.sheepType);
	}
}
